import { track } from "~/modules/analytics/track";
import { SearchEvents } from "../analytics/events/search";

// // // //
// CommandPalette Analytics

/**
 * trackCommandPaletteOpen
 * Tracks the CommandPaletteOpen event
 */
export function trackCommandPaletteOpen() {
    track(SearchEvents.CommandPaletteOpen);
}

/**
 * trackCommandPaletteClose
 * Tracks the CommandPaletteClose event
 */
export function trackCommandPaletteClose() {
    track(SearchEvents.CommandPaletteClose);
}

/**
 * trackCommandPaletteSelectResult
 * Tracks the CommandPaletteSelectResult event
 */
export function trackCommandPaletteSelectResult(props: {
    label: string;
    href: string;
}) {
    track(SearchEvents.CommandPaletteSelectResult, props);
}

// // // //
// GlobalSearch Analytics

/**
 * trackGlobalSearchOpen
 * Tracks the GlobalSearchOpen event
 */
export function trackGlobalSearchOpen() {
    track(SearchEvents.GlobalSearchOpen);
}

/**
 * trackGlobalSearchClose
 * Tracks the GlobalSearchClonse event
 */
export function trackGlobalSearchClose() {
    track(SearchEvents.GlobalSearchClose);
}

/**
 * trackGlobalSearchSelectResult
 * Tracks the GlobalSearchSelectResult event
 */
export function trackGlobalSearchSelectResult(props: {
    label: string;
    href: string;
}) {
    track(SearchEvents.GlobalSearchSelectResult, props);
}

// // // //
// Recent Searches Analytics

/**
 * trackRecentSearchAdd
 * Tracks when a search result is saved to recent searches
 */
export function trackRecentSearchAdd(props: { label: string; href: string }) {
    track(SearchEvents.RecentSearchAdd, props);
}

/**
 * trackRecentSearchClear
 * Tracks when the user clears all recent searches
 */
export function trackRecentSearchClear() {
    track(SearchEvents.RecentSearchClear);
}

// // // //
// Search Query Analytics

/**
 * trackSearchQuery
 * Tracks the user's search query
 */
export function trackSearchQuery(props: { query: string }) {
    track(SearchEvents.SearchQuery, props);
}
